module.exports = __webpack_public_path__ + "img/header_bg.b4d9015f.png";